import { Redirect } from 'expo-router';

export default function LearnAiLegacyIndexRedirect() {
  return <Redirect href="/learn/path/create" />;
}
